export default __webpack_public_path__ + "static/onboarding-contribute-7942411e8655fd98f5a4d6d12d5accdb.png";